export const INSURANCE_TYPES = {
  CAR: 'car',
  HOME: 'home',
  INCOME_PROTECTION: 'income-protection',
  LIFE: 'life',
  PET: 'pet',
  TRAVEL: 'travel',
} as const;

export const INSURANCE_TYPES_WITH_HEALTH = {
  ...INSURANCE_TYPES,
  HEALTH: 'health',
} as const;

export const INSURANCE_SUB_TYPES = {
  BALI: 'bali',
  CAT: 'cat',
  DOG: 'dog',
  JAPAN: 'japan',
  NEW_ZEALAND: 'new-zealand',
  PAYD: 'pay-as-you-drive',
  THAILAND: 'thailand',
} as const;

export const INSURANCE_SUB_TYPES_BY_INSURANCE_TYPE = {
  [INSURANCE_TYPES.PET]: [INSURANCE_SUB_TYPES.CAT, INSURANCE_SUB_TYPES.DOG],
  [INSURANCE_TYPES.TRAVEL]: [
    INSURANCE_SUB_TYPES.BALI,
    INSURANCE_SUB_TYPES.JAPAN,
    INSURANCE_SUB_TYPES.NEW_ZEALAND,
    INSURANCE_SUB_TYPES.THAILAND,
  ],
  [INSURANCE_TYPES.CAR]: [INSURANCE_SUB_TYPES.PAYD],
} as const;

export const COVERAGE_INCLUSION = {
  EXCLUDED: 'excluded',
  INCLUDED: 'included',
  OPTIONAL: 'optional',
};

export const PRODUCT_REVIEW_IDS = {
  car: 'car',
  home: 'home-and-contents',
  travel: 'travel',
} as const;

export const TRAVEL_PRODUCT_TYPES = {
  DOMESTIC: 'domestic',
  INTERNATIONAL: 'international',
};

export const SWISS_RE_TRANSFER_URL = '/swissre-transfer';
